module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1 && _vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "操作说明",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v(" 说明：第三方权益列表，对接合作的第三方，发送权益给第三方并记录。 ")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.matchHidePage('editor')
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    }
  }, [_vm._v("新增第三方权益")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 140
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "third_name",
      "label": "第三方名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.third_name === 'jh') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 交行 ")]) : _vm._e()]
      }
    }], null, false, 3337200955)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_name",
      "label": "权益名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "权益类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type === 'shopyhq') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 商城优惠券 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'distributionyhq') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 多店铺优惠券 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'points') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 积分 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'deposit') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 余额 ")]) : _vm._e()]
      }
    }], null, false, 1386255539)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_num",
      "label": "每人限量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_desc",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_param",
      "label": "额外参数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return undefined
      }
    }], null, false, 4154174436)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7bbd3a46", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bbd3a46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/thirds/setting/list.vue
// module id = 2850
// module chunks = 0